import React, { useState } from "react";
import { useImpactReadOnly, openImpactBoxIfReadOnly } from "app/routes/psp/management/useImpactReadOnly";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import { IntlGetText } from "util/IntlMessages";
import InfoCard from "components/InfoCard";
import CycleVialsDialog from "./CycleVialsDialog";
import { callActionApi, getCycleVialsInfo } from "api/apiList";
import { callStartImpact } from "actions/Impact";

const CycleVials = () => {
  const dispatch = useDispatch();
  const readOnlyImpactView = useImpactReadOnly();
  const { selectedPrescription } = useSelector(({ management }) => management);
  const { impactStartDate, consentSigned, isCIRequired } = useSelector(({ impact }) => impact);

  const [open, setOpen] = useState(false);
  const [cycleVialsInfo, setCycleVialsInfo] = useState([]);

  const msgConsentRequired = IntlGetText("impact.consentRequired");

  const handleClickOpen = () => {
    if (openImpactBoxIfReadOnly(readOnlyImpactView, () => setOpen(true))) return;
    if (!impactStartDate) {
      dispatch(callStartImpact(true));
      return;
    }
    if (isCIRequired && !consentSigned) {
      NotificationManager.warning(msgConsentRequired);
      return;
    }
    setOpen(true);
  };

  const callApi = (apiFunc, setData) => {
    callActionApi(
      apiFunc,
      setData,
      (error) => {
        if (typeof error === "string") NotificationManager.error(error);
      }
    );
  };

  const loadCycleVials = () => {
    callApi(
      () => getCycleVialsInfo(selectedPrescription.id),
      (data) => {
        setCycleVialsInfo(data);
      }
    );
  };

  const handleRequestClose = () => setOpen(false);

  return (
    <div>
      <InfoCard
        data={{
          icon: "hospital",
          title: IntlGetText("core.cycle.vials"),
          subTitle: IntlGetText("ledaga.cardSubTitle"),
          color: "#757575",
        }}
        onClickBox={handleClickOpen}
      />
      <CycleVialsDialog
        open={open}
        handleRequestClose={handleRequestClose}
        loadCycleVials={loadCycleVials}
        disableBackdropClick={true}
        cycleVialsInfo={cycleVialsInfo}
      />
    </div>
  );
};

export default CycleVials;
